export enum ChecklistTemplateShareSettingsOptions {
  Public = "public",
  Private = "private",
}

export const CHECKLIST_TEMPLATE_SHARE_SETTINGS_OPTIONS = [
  { label: "Public", value: ChecklistTemplateShareSettingsOptions.Public },
  { label: "Private", value: ChecklistTemplateShareSettingsOptions.Private },
];

export const CHECKLIST_TEMPLATE_SHARE_SETTINGS_LABELS = {
  [ChecklistTemplateShareSettingsOptions.Public]: "Public",
  [ChecklistTemplateShareSettingsOptions.Private]: "Private",
};

export enum TemplateSubmitActions {
  Create = "create",
  Update = "update",
}

export enum CHECKLIST_TEMPLATE_SORT_KEYS {
  TEMPLATE_NAME = "templateName",
}

export const CHECKLIST_TEMPLATE_SORT_KEYS_MAP = {
  [CHECKLIST_TEMPLATE_SORT_KEYS.TEMPLATE_NAME]: "title",
};
